import { Geotab } from "@fairfleet/geotab";

export default function executeCmdOnDevices(
  geotabClient: Geotab,
  deviceIds: string[],
  cmd: string,
  channels: Record<string, number | null>,
) {
  deviceIds.map(id => {
    if (id in channels && channels[id] != null && channels[id] != 0) {
      geotabClient.call("Add", {
        typeName: "TextMessage",
        entity: {
          device: { id },
          messageContent: {
            contentType: "MimeContent",
            mimeType: "cmd",
            data: btoa(cmd),
            channelNumber: channels[id],
          },
          isDirectionToVehicle: true,
        },
      });
    }
  });
}
